import { z } from 'zod';

// Regex patterns for validation
const nameRegex = /^[a-zA-Z\s'-]+$/;
const phoneRegex = /^\+?[1-9]\d{1,14}$/;
const partNumberRegex = /^[a-zA-Z0-9-_\/]+$/;
const orderNumberRegex = /^[a-zA-Z0-9-]+$/;

// Contact Form Schema
export const contactFormSchema = z.object({
  firstName: z.string().min(2, "First name is too short").regex(nameRegex, "Invalid characters in name"),
  lastName: z.string().min(2, "Last name is too short").regex(nameRegex, "Invalid characters in name"),
  email: z.string().email("Invalid email address"),
  company: z.string().optional(),
  phone: z.string().regex(phoneRegex, "Invalid phone number").optional().or(z.literal('')),
  industry: z.string().optional(),
  subject: z.string().min(5, "Subject is too short"),
  message: z.string().min(10, "Message is too short"),
});

// Support Form Schema
export const supportFormSchema = z.object({
  name: z.string().min(2, "Name is too short").regex(nameRegex, "Invalid characters in name"),
  email: z.string().email("Invalid email address"),
  company: z.string().optional(),
  phone: z.string().regex(phoneRegex, "Invalid phone number").optional().or(z.literal('')),
  partNumber: z.string().regex(partNumberRegex, "Invalid part number").optional().or(z.literal('')),
  urgency: z.string().nonempty("Urgency is required"),
  issueDescription: z.string().min(20, "Please provide a detailed description"),
});

// Returns Form Schema
export const returnsFormSchema = z.object({
  orderNumber: z.string().min(3, "Order number is too short").regex(orderNumberRegex, "Invalid order number"),
  email: z.string().email("Invalid email address"),
  name: z.string().min(2, "Name is too short").regex(nameRegex, "Invalid characters in name"),
  phone: z.string().regex(phoneRegex, "Invalid phone number").optional().or(z.literal('')),
  partNumbers: z.string().min(3, "Part numbers are required"),
  returnReason: z.string().nonempty("Return reason is required"),
  additionalDetails: z.string().optional(),
});

// Career Application Form Schema
export const careerApplicationSchema = z.object({
  firstName: z.string().min(2, "First name is too short").regex(nameRegex, "Invalid characters in name"),
  lastName: z.string().min(2, "Last name is too short").regex(nameRegex, "Invalid characters in name"),
  email: z.string().email("Invalid email address"),
  phone: z.string().regex(phoneRegex, "Invalid phone number").optional().or(z.literal('')),
  position: z.string().nonempty("Please select a position"),
  linkedinOrPortfolio: z.string().url("Enter a valid URL").optional().or(z.literal('')),
  resumeUrl: z.string().url("Enter a valid URL to your resume").optional().or(z.literal('')),
  coverMessage: z.string().min(20, "Please provide a bit more detail (at least 20 characters)"),
});
